import { Grid, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

export const ShowPerfilEmpresarial=({ perfilEmpresarial })=> {
    const { t } = useTranslation()
  
    return (
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}>
            
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.cif')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.nif}
                </Typography>
            </Grid>
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.nombre')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.razon_social}
                </Typography>
            </Grid>
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.volumenNegocio')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.volumenNegocio.texto}
                </Typography>
            </Grid>
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.comunidadAutonoma')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.comunidadAutonoma.nombre_comunidad}
                </Typography>
            </Grid>
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.provincia')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.provincia.nombre_provincia}
                </Typography>
            </Grid>
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.municipio')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.municipio.nombre_municipio}
                </Typography>
            </Grid>
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.cnaePrincipal')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.cnaE_Sector.texto_sector}
                </Typography>
            </Grid>
            <Grid 
            container spacing={0.1}
            justifyContent="flex-start"
            alignItems="flex-start">
                <Typography sx={{fontWeight: 'bold'}}>
                    {t('crearPerfilEmpresarial.divisiones')}
                </Typography>
                <Typography sx={{marginRight:'2px'}}>:</Typography>
                <Typography>
                    {perfilEmpresarial?.cnaE_Division.division_texto}
                </Typography>
            </Grid>
      </Stack>
    )
}